<div class="flexbox-row justify-content-between">
    <div class="vertical-items">
        <button mat-button aria-label="Back" class="button-text" (click)="goBackToExportData();$event.stopPropagation()">
            <span class="flexbox-row gap-8">
                <i class="fa-regular fa-chevron-left"></i>
                <span class="button-label">Export Data</span>
            </span>
        </button>
        <ng-container>
            <h1 class="title h3">Export Custom Data</h1>
        </ng-container>
    </div>
</div>
<div class="content-block-main overflow-hidden gap-20 p-0">
    <ng-container *ngIf="!viewEngagements">
        <div class="flexbox-row justify-content-between flex-wrap">
            <div class="stepper w-500 stepper-v1">
                <div class="step-item" [ngClass]="!viewEngagements ? 'active' : 'completed'">
                    <div class="step-action" (click)="viewEngagements=false">
                        <span class="space-line"></span>
                        <span class="step-circle"></span>
                        <div class="content-area">
                            <h6 class="title">Select Clients</h6>
                        </div>
                    </div>
                </div>

                <div class="step-item" [ngClass]="{'active': viewEngagements}">
                    <div class="step-action"
                        [ngClass]="{'step-item-inner': !viewEngagements,'step-item-inner-next':viewEngagements}">
                        <span class="space-line"></span>
                        <span class="step-circle"></span>
                        <div class="content-area">
                            <h6 class="title">Select Engagements</h6>
                        </div>
                    </div>
                </div>
            </div>

            <button mat-button mat-flat-button color="primary" class="button-default" (click)="onViewEngagements();$event.stopPropagation()"
                [disabled]="!selectedClientData.length">Step 2</button>
        </div>
        <div class="h-100 gap-32 column-gap-32 p-4 overflow-hidden flex-1 flex-wrap border-top px-0 d-flex flex-column">
            <h4>Choose from below list of clients to view engagements</h4>
            <div class="cards-group flex-1 overflow-hidden gap-20 column-gap-20 justify-content-center">
                <div class="card-width flexbox-column flex-1">
                    <p class="text-gray-9">Select from available client(s)</p>
                    <div class="card flex-1 h-100 overflow-hidden">
                        <div class="card-header border-0 pt-4">
                            <div class="d-flex w-100 mb-3">
                                <mat-form-field class="fixed-label label-none flex-1 icon-form-before ml-2"
                                    floatLabel="always">
                                    <mat-label>Search</mat-label>

                                    <input matInput placeholder="Search from available clients" [formControl]="searchAllClient" autocomplete="off">
                                <span matPrefix>
                                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                                </span>
                                </mat-form-field>
                            </div>
                            <div class="d-flex flex-row">
                                <span class="text-primary fw-semibold mr-2 cursor-pointer"
                                    (click)="toggleSelection(filteredNonSelClient, true, 'nonselected')"
                                    [ngStyle]="{'opacity': (!filteredNonSelClient?.length)  ? '0.5' : ' 1'}">Select
                                    all</span>
                                <span class="vertical-border"></span>
                                <span class="fw-semibold cursor-pointer"
                                    [ngStyle]="{'opacity':  !isClearEnabled(filteredNonSelClient) ? '0.5' : ' 1'}"
                                    (click)="toggleSelection(filteredNonSelClient, false, 'nonselected')"
                                    [ngClass]="{'text-primary': isClearEnabled(filteredNonSelClient)}">
                                    Clear Selection</span>
                            </div>
                        </div>
                        <div class="card-body flex-1 overflow-auto">
                            <div class="mat-list-item d-block column-count">
                                <ng-container *ngFor="let client of filteredNonSelClient">
                                    <span class="item-checkbox item-title pb-2">
                                        <mat-checkbox [(ngModel)]="client.isChecked" class="clients-lists"
                                            (change)="singleCheck(nonSelectedClientData, client.clientId, client.isChecked)">
                                            {{client.clientName}}
                                        </mat-checkbox>
                                    </span>
                                </ng-container>
                            </div>
                            <ng-container
                                *ngIf="searchAllClient?.value && searchAllClient.value?.trim()?.length && !filteredNonSelClient.length">
                                <div class="no-data-found">
                                    <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg"
                                        alt="Icon">
                                    <h5>No client found</h5>
                                    <p>
                                        Your search "{{searchAllClient.value}}" did not match any clients. </p>
                                    <p>Please try again.</p>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="card-arrows-img">
                    <button mat-button mat-stroked-button color="dark" class="button-default-icon border-0 bg-white"
                        (click)="moveToSelected()" [disabled]="isMoveToSelectedDisabled()">
                        <i class="fa-light fa-square-arrow-right left-right-arrow"></i>
                    </button>

                    <button mat-button mat-stroked-button color="dark" class="button-default-icon border-0 bg-white"
                        (click)="moveFromSelected()" [disabled]="isMoveFromSelectedDisabled()">
                        <i class="fa-light fa-square-arrow-left left-right-arrow"></i>
                    </button>
                </div>
                <div class="card-width flexbox-column flex-1">
                    <p class="text-gray-9">Selected client(s)</p>
                    <div class="card flex-1 h-100 overflow-hidden">
                        <div class="card-header border-0 pt-4">
                            <div class="d-flex w-100 mb-3">
                                <mat-form-field class="fixed-label label-none flex-1 icon-form-before w-100"
                                    floatLabel="always">
                                    <mat-label>Search</mat-label>
                                    <input matInput placeholder="Search from selected clients"
                                        [formControl]="searchSelectClient" autocomplete="off">
                                    <span matPrefix>
                                        <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                                    </span>
                                </mat-form-field>
                            </div>
                            <div class="d-flex flex-row">
                                <span class="fw-semibold mr-2 cursor-pointer"
                                    [ngClass]="{'text-primary': filteredSelectedClient.length}"
                                    (click)="toggleSelection(filteredSelectedClient, true, 'selected')"
                                    [ngStyle]="{'opacity':  !filteredSelectedClient.length  ? '0.5' : ' 1'}">Select
                                    all</span>
                                <span class="vertical-border"></span>
                                <span class="fw-semibold cursor-pointer"
                                    [ngStyle]="{'opacity':  !isClearEnabled(filteredSelectedClient) ? '0.5' : ' 1'}"
                                    (click)="toggleSelection(filteredSelectedClient, false, 'selected')"
                                    [ngClass]="{'text-primary': isClearEnabled(filteredSelectedClient)}">
                                    Clear Selection</span>
                            </div>
                        </div>
                        <div class="card-body flex-1 overflow-auto">
                            <div class="mat-list-item d-block column-count">
                                <ng-container *ngFor="let client of filteredSelectedClient">
                                    <span class="item-checkbox item-title pb-2">
                                        <mat-checkbox [(ngModel)]="client.isChecked"
                                            (change)="singleCheck(selectedClientData, client.clientId, client.isChecked)" class="clients-lists">
                                            {{client.clientName}}
                                        </mat-checkbox>
                                    </span>
                                </ng-container>
                            </div>
                            <ng-container
                                *ngIf="searchSelectClient.value && searchSelectClient.value.trim().length && !filteredSelectedClient.length">
                                <div class="no-data-found">
                                    <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg"
                                        alt="Icon">
                                    <h5>No client found</h5>
                                    <p>
                                        Your search "{{searchSelectClient.value}}" did not match any clients. </p>
                                    <p>Please try again.</p>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="viewEngagements">
        <div class="flexbox-row justify-content-between flex-wrap">
            <div class="stepper w-500 stepper-v1">
                <div class="step-item"  [ngClass]="!viewEngagements ? 'active' : 'completed'">

                    <div class="step-action" (click)="viewEngagements=false">

                        <span class="space-line"></span>
                        <span class="step-circle"></span>
                        <div class="content-area">
                            <h6 class="title m-0 text-primary" role="button">Select Clients</h6>
                        </div>

                    </div>
                </div>
                <div class="step-item" [ngClass]="{'completed': viewEngagements}">
                    <div class="step-action"
                        [ngClass]="{'step-item-inner': !viewEngagements,'step-item-inner-next':viewEngagements}">
                        <span class="space-line"></span>
                        <span class="step-circle"></span>
                        <div class="content-area">
                            <h6 class="title m-0">Select Engagements</h6>
                        </div>

                    </div>

                </div>
            </div>
            <button mat-button mat-flat-button color="primary" class="button-default px-3"
                (click)="goBackToStep1();$event.stopPropagation()">Back to Step 1</button>
        </div>
        <div class="flexbox-row justify-content-between flex-wrap flex-sm-nowrap">
            <p class="fw-medium" *ngIf="!loadEngGrid">Total '{{clientCount}} Clients' and '{{engCount}}
                Engagements'</p>
            <div class="flexbox-row justify-content-end">
                <mat-form-field class="fixed-label label-none flex-1 icon-form-before" floatLabel="always">
                    <mat-label>Search</mat-label>
                    <input matInput placeholder="Search here" [formControl]="searchEngagement" autocomplete="off">
                    <span matPrefix>
                        <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                    </span>
                </mat-form-field>
                <button mat-button mat-flat-button color="primary" class="button-default" (click)="onBtnExport()"
                    [disabled]="isExportDataDisabled()">
                    <i class="fa-regular fa-file-export"></i>Export Data
                </button>
            </div>
        </div>
        <div class="card table-responsive flex-1">
            <table mat-table [dataSource]="dataSource" matSort class="table-countable">

                <!-- All Columns -->
                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                    <ng-container *ngIf="column === 'select';else other">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="isAllSelected()"
                                [disabled]="hasNoEngagements()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-template #other>
                        <th class="text-center" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{columnDefs[column]}}
                            <button *ngIf="['engagementType', 'financialYearEndDate', 'partnerName'].includes(column)"
                                mat-icon-button [matMenuTriggerFor]="menu" #assignSortTrigger="matMenuTrigger"
                                (click)="$event.stopPropagation()">
                                <i class="fa-solid fa-bars-filter fs-15"></i>
                            </button>
                            <mat-menu #menu="matMenu" #beforeMenu="matMenu" xPosition="before" class="mt-1">
                                <div class="button-group justify-content-end p-2 border-bottom">
                                    <button mat-button class="button-text fs-12"
                                        (click)="clearFilter(column);$event.stopPropagation();">Clear
                                        All</button>
                                </div>
                                <div class="mat-list-item d-block overflow-auto">
                                    <ng-container *ngFor="let col of columnFilterData[column];">
                                        <button mat-menu-item>
                                            <mat-checkbox [checked]="col.isChecked"
                                                (change)='onFilterChanged(column, col, $event.checked)'
                                                (click)="$event.stopPropagation()">
                                                <!-- {{ col.value ?((column !== 'engagementType') ? col.value : (col.value.includes('Compilation')) ? 'Compilation': (col.value.includes('Review')) ? 'Review': (col.value.includes('T2')) ? 'T2 (Corporations)': (col.value.includes('C Corp')) ? '1120 (C Corp)': (col.value.includes('S Corp')) ? '1120 (S Corp)': (col.value.includes('1065')) ? '1065 (LLC)': '') : '(Blank)'}} -->
                                                {{
                                                col.value
                                                ? (column !== 'engagementType')
                                                ? col.value
                                                : (col.value.includes('Compilation')) ? 'Compilation'
                                                : (col.value.includes('Review')) ? 'Review'
                                                : (col.value.includes('T2')) ? 'T2 (Corporations)'
                                                : (col.value.includes('C Corp')) ? '1120 (C Corp)'
                                                : (col.value.includes('S Corp')) ? '1120 (S Corp)'
                                                : (col.value.includes('1065')) ? '1065 (LLC)'
                                                : ''
                                                : '(Blank)'
                                                }}
                                            </mat-checkbox>
                                        </button>
                                    </ng-container>
                                </div>
                            </mat-menu>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <span *ngIf="column !== 'engagementType'; else engType">{{row[column]}} </span>
                            <ng-template #engType>
                                <p *ngIf="row[column].includes('Compilation')"
                                    class="badge badge-pills badge-medium  badge-purple">Compilation</p>
                                <p *ngIf="row[column].includes('Review')"
                                    class="badge badge-pills badge-medium  badge-tertiary-blue">Review</p>
                                <p *ngIf="row[column].includes('T2')"
                                    class="badge badge-pills badge-medium  badge-pink">T2 (Corporations)</p>
                                <p *ngIf="row[column].includes('1120')"
                                    class="badge badge-pills badge-medium  badge-pink">1120 (C Corp)</p>
                                <p *ngIf="row[column].includes('1120S')"
                                    class="badge badge-pills badge-medium  badge-pink">1120S (S Corp)</p>
                                <p *ngIf="row[column].includes('1065')"
                                    class="badge badge-pills badge-medium  badge-pink">1065 (LLC)</p>
                            </ng-template>
                        </td>
                    </ng-template>
                </ng-container>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                        <ng-container *ngIf="!loadEngGrid">
                            <div class="no-data-found">
                                <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                                @if (!hasNoEngagements() && searchEngagement?.value) {
                                <h5>No data found.</h5>
                                <p>
                                    Your search "{{ searchEngagement?.value }}" did not match any data. </p>
                                <p>Please try again.</p>
                                }
                                @if (hasNoEngagements()) {
                                <h5>There are no Archived Engagement's for the selected client(s).</h5>
                                }
                            </div>
                        </ng-container>
                    </td>
                </tr>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>

    </ng-container>
</div>